import { electricityLogo } from "@/constants";
import React from "react";

const ElectricityTile = () => {
  return (
    <div className="mt-1">
      <div className="grid grid-cols-4 justify-between">
        {electricityLogo.map((network, index) => (
          <div key={index}>
            <div className="w-fit rounded-lg p-2">
              <img
                src={network.img}
                alt="network-logo"
                className="size-20 rounded-lg object-contain"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ElectricityTile;
